import { withHost } from 'utils';

export const Api = {
  GetDatasetsByName: (datasetName, pageSize, pageNumber) =>
    withHost(`/datasets/${datasetName}?pageSize=${pageSize}&pageNumber=${pageNumber}`),
  CreateDataset: (name) => withHost(`/datasets/${name}`),
  UpdateDataset: (recordId) => withHost(`/datasets/id/${recordId}`),
  DeleteDataset: (recordId) => withHost(`/datasets/id/${recordId}`),
  RemoveOrder: (id) => withHost(`/orders/${id}`),
};
